import { render } from "./serviceCharge.vue?vue&type=template&id=c3175aa4&scoped=true"
import script from "./serviceCharge.vue?vue&type=script&lang=js"
export * from "./serviceCharge.vue?vue&type=script&lang=js"

import "./serviceCharge.vue?vue&type=style&index=0&id=c3175aa4&scoped=true&lang=css"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3175aa4"]])

export default __exports__